/*
 * Every word on the site lives here, so a copy change is a one-file edit.
 *
 * Source: the old WordPress database in rescue/content (pages 96 Main Home,
 * 8908 About, 4077 Contact, 4038 Events; testimonials; event_listing posts).
 * Theme demo filler (team members, portfolio, blog posts, "Client N" logos)
 * was left behind on purpose.
 *
 * The copy was last edited in 2020. Items marked CONFIRM are facts that may
 * have changed since then.
 */

export const contact = {
  street: "116 E 7th Street",
  city: "Royal Oak, MI 48067",
  phone: "248 583 2476",
  phoneHref: "tel:+12485832476",
  email: "info@platform18.org",
  mapsHref:
    "https://www.google.com/maps/search/?api=1&query=116+E+7th+Street+Royal+Oak+MI+48067",
  social: [
    { label: "Instagram", href: "https://www.instagram.com/platformeighteen/" },
    { label: "Facebook", href: "https://www.facebook.com/Platform18RoyalOak/" },
    { label: "Twitter", href: "https://twitter.com/Platform18_" },
  ],
};

export const pillars = [
  {
    image: "/images/pillar-relationships.png",
    title: ["meaningful", "relationships"],
    body: "Meet thoughtful, like-minded millennials and connect over vibrant discussions, exciting events and better-than-Bubby’s food.",
    kicker: "Finally, a chance to actually meet the (cool) people in your neighborhood.",
  },
  {
    image: "/images/pillar-experiences.png",
    title: ["stimulating", "experiences"],
    body: "Memorable cookouts, unforgettable trips, and gripping presentations. Take part in events that will enrich, intrigue, and challenge you.",
    kicker: "Plus, the chance to request, create or host the events YOU want.",
  },
  {
    image: "/images/pillar-connection.png",
    title: ["jewish", "connection"],
    body: "Meet mentors and educators who become fast friends. Ask ANYTHING about Judaism (or skiing or life), and feel confident you’re getting the #realdeal.",
    kicker: "Plus, fascinating workshops and Q&As that’ll keep you on the edge of your seat.",
  },
];

// CONFIRM: these are the 2020 numbers from the old home page.
export const stats = [
  { value: "20", label: "Bar stools", icon: "/images/home/stat-stools.svg" },
  { value: "73", label: "Average attendees daily", icon: "/images/home/stat-attendees.svg" },
  { value: "167", label: "Average cuppa Joes daily", icon: "/images/home/stat-coffee.svg" },
  { value: "12", label: "Events weekly", icon: "/images/home/stat-events.svg" },
  { value: "1300", label: "Mbps WiFi speed", icon: "/images/home/stat-wifi.svg" },
  { value: "15", label: "Team members", icon: "/images/home/stat-team.svg" },
];

// The home page gallery, in the order the 2020 site showed it.
export const gallery = [
  { src: "/images/space-bar.jpg", alt: "The coffee bar with brass stools" },
  { src: "/images/space-library.jpg", alt: "Bookshelves against a red wall" },
  { src: "/images/space-deck.jpg", alt: "The covered outdoor deck with sofas" },
  { src: "/images/space-lounge.jpg", alt: "Lounge with a vintage trunk and sofa" },
  { src: "/images/space-clocks.jpg", alt: "World clocks above the windows" },
  { src: "/images/space-warning.jpg", alt: "Warning: this place can be addictive. Enter at your own risk." },
];

// CONFIRM: membership was free in 2020. The membership app may change this.
export const faqs = [
  {
    q: "The place is cool! But what do I actually do at P18?",
    a: [
      "Anything, m’dear. (’cept snorkeling. No snorkeling. Sorry.)",
      "Want a WiFi-friendly, WeWork-style, oh-so-kosher space to knock out your Asana list? Drop in anytime with a laptop and Get. Stuff. Done. (You productivity ninja, you!)",
      "Want to zone out and chill cause who invented this adulting thing anyway? Come hang out and relax in a plush recliner with awesome people. We also host dozens of cool events each month you can attend for free.",
    ],
  },
  {
    q: "Do I have to pay to become a member?",
    a: [
      "Not a cent. You’ve got enough expenses on your plate. Enjoy good stuff for FREE at P18: the place, the company, even some food.",
    ],
  },
  {
    q: "Can I come with friends?",
    a: [
      "Absolutely. Bring your colleagues, your partner, your Boston terrier. (Don’t bring party pooper Jerry from Art History. Just don’t.)",
    ],
  },
];

export const testimonials = [
  {
    quote:
      "A full year after arriving in Detroit, I was still spinning my wheels and I didn’t have the Jewish community I wanted. Then I was introduced to Noam Gross of Partners, who encouraged me to attend Shabbat dinners. I finally found my niche in the Jewish community.",
    title: "Finally found my niche in the Jewish community",
    name: "Sam Shrago",
    role: "Systems engineer at General Motors",
    photo: "/images/t-sam-shrago.png",
    cutout: "/images/tc-sam-shrago.png",
  },
  {
    quote:
      "If you need a Shabbat dinner, if you need a trip, a sports activity, someone to get coffee with — whatever you need, they’re there for you. And my favorite part is the people.",
    title: "My favorite part is the people",
    name: "Becca Fishman",
    role: "Israel and Camp Coordinator, Tamarack Camps",
    photo: "/images/t-becca-fishman.png",
    cutout: "/images/tc-becca-fishman.png",
  },
  {
    quote:
      "When you leave school, this allows you to continue your learning — but in a way that’s even more valuable and meaningful in your life. It really helped me find purpose and direction.",
    title: "Purpose and direction",
    name: "Abby Wolfson",
    role: "Practice manager at Wolfson Dental",
    photo: "/images/t-abby-wolfson.png",
    cutout: "/images/tc-abby-wolfson.png",
  },
  {
    quote: "Platform 18 is a great opportunity to connect with Judaism — and make it your own.",
    title: "An opportunity to make Judaism your own.",
    name: "Ethan Siegel",
    role: "Health and benefit consultant at Aon",
    photo: "/images/t-ethan-siegel.png",
    cutout: "/images/tc-ethan-siegel.png",
  },
  {
    quote:
      "Now, I don’t just hang out with friends. I actually tackle my coursework, work hard to uphold Jewish values, and will marry into our faith. I understand where I came from and feel blessed to be Jewish.",
    title: "Judaism has become something that defines me and something I love.",
    name: "Jared Arbit",
    role: "Student at Michigan State University",
    photo: "/images/t-jared-arbit.png",
    cutout: "/images/tc-jared-arbit.png",
  },
];

/*
 * CONFIRM: the recurring programs from the 2020 events calendar. The one-off
 * 2020 events (Purim party, Passover paint night, the trips) are not listed.
 * Edit this list to match what actually runs today.
 */
export const programs = [
  {
    title: "The Chaburah with Rabbi Noam Gross",
    when: "Weekly · Wednesdays",
  },
  {
    title: "Girl Talk with Erin Stiebel",
    when: "Weekly · Mondays",
  },
  {
    title: "Men’s Club",
    when: "Weekly · Tuesdays",
  },
  {
    title: "Jewish Book Club",
    when: "Monthly",
  },
  {
    title: "Jewish Holiday Basics",
    when: "Monthly",
  },
  {
    title: "Shabbat in an Hour",
    when: "Ask us for the next date",
  },
];
